import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import socket from "../../socket";
import { getUser } from "../../auth";

const URL = process.env.REACT_APP_API_URL;

export default function UltimasVentas() {
  const [ventas, setVentas] = useState([]);
  const [expandedId, setExpandedId] = useState(null);

  const fetchUltimasVentas = () => {
    const user = getUser();
    fetch(`${URL}/api/sales/summary/last-3/`, {
      headers: {
        "X-Empresa-Id": user?.empresa_id,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Error al obtener ventas");
        return res.json();
      })
      .then(setVentas)
      .catch(() => setVentas([]));
  };

  useEffect(() => {
    fetchUltimasVentas();
  }, []);

  useEffect(() => {
    socket.on("venta_creada", fetchUltimasVentas);
    socket.on("venta_borrada", fetchUltimasVentas);
    socket.on("venta_editada", fetchUltimasVentas);
  
    return () => {
      socket.off("venta_creada", fetchUltimasVentas);
      socket.off("venta_borrada", fetchUltimasVentas);
      socket.off("venta_editada", fetchUltimasVentas);
    };
  }, []);

  const handleExpand = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  const formatDate = (fechaStr) => {
    return new Date(fechaStr)
      .toLocaleString("es-AR", {
        day: "2-digit",
        month: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
      .replace(",", " -");
  };

  return (
    <Box
      sx={{
        width: "90%",
        height: "96%",
        p: 1,
        bgcolor: "#171717",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        borderRadius: 2, 
      }}
    >
      <Typography variant="h6" fontWeight="bold" color="white" gutterBottom>
        Últimas 3 ventas
      </Typography>

      {expandedId === null ? (
        <Box sx={{ display: "flex", flexDirection: "column", mt:1,  flex: 1 }}>
          {ventas.map((venta) => (
            <Accordion
              key={venta.id}
              expanded={false}
              onClick={() => handleExpand(venta.id)}
              sx={{
                bgcolor: "#2a2a2a",
                color: "#fff",
                cursor: "pointer",
                boxShadow: "5px 10px 15px rgba(0,0,0,0.8)"
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography>Venta: {formatDate(venta.date)} - {venta.payment}</Typography>
                  <Typography variant="body2">Total: ${venta.total}</Typography>
                </Box>
              </AccordionSummary>
            </Accordion>
          ))}
        </Box>
      ) : (
        <Box sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          bgcolor: "#2a2a2a",
          color: "#fff",
          borderRadius: 1,
          overflow: "hidden"
        }}>
          <Box
            onClick={() => setExpandedId(null)}
            sx={{
              pt: 1.4,
              pl: 2,
              pb: 1.4,
              pr: 1,
              borderBottom: "1px solid #232324",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <Box>
              <Typography>
                Venta: {formatDate(ventas.find(v => v.id === expandedId)?.date)} - {
                  ventas.find(v => v.id === expandedId)?.payment
                }
              </Typography>
              <Typography variant="body2">
                Total: ${ventas.find(v => v.id === expandedId)?.total}
              </Typography>
            </Box>
            <IconButton sx={{ transform: "rotate(180deg)" }}>
              <ExpandMoreIcon sx={{ color: "#fff" }} />
            </IconButton>
          </Box>

          <Box sx={{
            flex: 1,
            overflowY: "auto",
            p: 0
          }}>
            <List dense>
              {ventas.find(v => v.id === expandedId)?.products.map((p) => (
                <ListItem key={p.product_id}>
                  <ListItemText
                    primary={`${p.name}`}
                    secondary={
                      p.sell_method === "Decimal"
                        ? `Cantidad: ${
                            p.quantity_reference >= 1000
                              ? `${p.quantity / p.quantity_reference}kg`
                              : `${p.quantity}gr`
                          } - Precio por ${p.quantity_reference >= 1000 ? "kg" : "100gr"}: $${p.price}`
                        : `Cantidad: ${p.quantity} - Precio por unidad: $${p.price}`
                    }
                    primaryTypographyProps={{ color: "#ffffff" }}
                    secondaryTypographyProps={{ color: "#cccccc" }}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        </Box>
      )}
    </Box>
  );
}
